module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Foreword"
    }
  }, [_vm._v("Foreword, by John Taliaferro")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Author_Notes"
    }
  }, [_vm._v("Author’s Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1"
    }
  }, [_vm._v("1. 1885: Hunting and Fishing in the St. Mary’s Lakes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. 1886: Meanwhile, Back in New York")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. 1887: Exploring the Glacier")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. 1888: Honoring Piegan Friends")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. 1889: Goat Expedition in British Columbia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. 1890: More Mapping and Discovery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. 1891: Yale Men Can’t Shoot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#C8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. 1895: Agreement to Purchase Blackfeet Mountain Land")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter9#C9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. 1897: Over the Garden Wall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. 1898: Who Is the Biggest Man?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11#C11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. 1901: Crown of the Continent, September")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter12#C12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. 1907–1910: The Legislative Process")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter13#C13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. 1910–1915: Park Improvements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter14#C14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. 1923: Visit to the Park with Elizabeth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter15#C15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. 1925: Theodore Roosevelt Medal for Distinguished Service")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter16#C16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. 1926: Last Visit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter17#C17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. 1927–1938: Last Years")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix. Geological Features Named by George Bird Grinnell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 63
// module chunks = 0